/**
 * Rolling frame-rate sampler.
 *
 * Reports an average over a time window rather than an instantaneous rate, so
 * one slow frame - the first one, which pays for shader compilation - does not
 * pin the reading low.
 */
export interface FpsSampler {
  /** Feed one frame's delta in seconds. Returns a reading when the window closes, else null. */
  push(deltaSeconds: number): number | null;
}

export function createFpsSampler(windowSeconds = 0.5): FpsSampler {
  if (windowSeconds <= 0) throw new RangeError('windowSeconds must be greater than 0');

  let frames = 0;
  let elapsed = 0;

  return {
    push(deltaSeconds) {
      frames += 1;
      elapsed += deltaSeconds;
      if (elapsed < windowSeconds) return null;

      const fps = Math.round(frames / elapsed);
      frames = 0;
      elapsed = 0;
      return fps;
    },
  };
}
